import useHeader from './header';

export default function useFavorites({ store, router }) {
  const { getHeader } = useHeader({ router, store });

  const sendFavoritesAdd = (body) => store.$apiBFF.sendPersEvent({ type: 'wish-list/add-to-wish-list', data: { header: getHeader(), body } });

  const sendFavoritesRemove = (body) => store.$apiBFF.sendPersEvent({ type: 'wish-list/remove-from-wish-list', data: { header: getHeader(), body } });

  return {
    sendFavoritesAdd,
    sendFavoritesRemove,
  };
}
